<template>
  <div ref="layout" class="page-form">
    <h3 class="title">客户信息修改</h3>

    <div class="container">
      <div class="tools" style="margin-bottom: 10px">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="保存" type="primary" @click="saveData" />
      </div>
      <template v-if="clientData !== null">
        <base-info ref="info" :client-data="clientData">
          <template #role>
            <role ref="role" :role="clientData.ROLES" />

          </template>
          <template #relation>
            <client-relation ref="relation" :relation="clientData.RELATION" />

          </template>
          <template #bank>
            <bank-info ref="bank" :bank="clientData.BANK" />

          </template>
        </base-info>
      </template>
    </div>
  </div>
</template>
<script>
import BaseInfo from './components/BaseInfo.vue'
import Role from './components/Role.vue'
import ClientRelation from './components/ClientRelation.vue'
import BankInfo from './components/BankInfo.vue'
import { apiFindCustomerApprove } from '@/api/client'

import { getClientDetail, clientSave } from '@/api/sap/client-sap'
export default {
  name: 'client-edit',
  components: { BaseInfo, Role, ClientRelation, BankInfo },
  data() {
    return {
      PARTNER: '',
      loading: true,
      clientData: null
    }
  },
  created() {
    this.PARTNER = this.$route.query.code
    this.getInfo()
  },
  methods: {
    async getInfo() {
      this.loading = true

      try {
        const { DATA } = await getClientDetail({ PARTNER: this.PARTNER })
        const approve = await apiFindCustomerApprove({ customerCode: this.PARTNER })
        this.clientData = DATA
        this.clientData.approve = approve?.data || {}
      } catch (e) {
        //
        this.clientData = {}
      }

      this.loading = false
    },
    async saveData() {
      const info = this.$refs.info.submitForm()
      if (!info) return
      const ROLES = this.$refs.role.submitForm()
      const RELATION = this.$refs.relation.submitForm()
      const bankResult = this.$refs.bank.submitForm()
      // 处理银行信息：提取 data 作为 BANK，changes 作为变更项
      const BANK = (bankResult && bankResult.data) ? bankResult.data : (Array.isArray(bankResult) ? bankResult : [])
      const BANK_CHANGES = (bankResult && bankResult.changes) ? bankResult.changes : []
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...info,
        RELATION,
        ROLES,
        BANK,
        BANK_CHANGES
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // info.approve.customerName = info.INFO.NAME_ORG1

      try {
        const { MSGTYPE, MESSAGE } = await clientSave(params)
        if (MSGTYPE === 'S') {
          this.$message.success(MESSAGE)
          await this.getInfo()
          this.$refs.info.getInfo()
        } else {
          this.$message.error(MESSAGE)
        }
      } catch (e) {
        //
      }

      this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
        loading.close()
      })
    },
    setInfo(data) {
      this.customerInfo = data
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/clientEdit.vue